/**
 * Outbound postMessage protocol for embedded agent runtime (P2-12).
 *
 * All messages are emitted to `window.parent` only when the runtime is running
 * inside an iframe. When the runtime is the top-level document, `emit()` is a
 * no-op — this makes the standalone agent page indistinguishable from the
 * embedded one at the call sites.
 *
 * `targetOrigin: '*'` is intentional. Beta hosts pin the iframe `src` under
 * their control and cross-check the incoming `message.source === iframe.contentWindow`
 * on their side. Session credentials are short-TTL ephemeral tokens minted by
 * the session-mint endpoint and never included in these messages.
 *
 * See `public/embed.md` for the host-side contract.
 */
export type CloneAIMessage =
  | { type: 'cloneai:ready'; agentId: string }
  | { type: 'cloneai:session-start' }
  | { type: 'cloneai:session-end'; durationSec: number }
  | { type: 'cloneai:cta-click'; ctaId: string; url: string }
  | { type: 'cloneai:error'; code: string; message: string };

export function emit(msg: CloneAIMessage): void {
  // Only emit when inside an iframe.
  if (window.parent === window) return;
  window.parent.postMessage(msg, '*');
}
